import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import { ManualReviewAutomatedReviewLogPayload } from 'models/automation/Reviews';
import API from 'services/API';

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    unknown,
    BaseErrorResponse,
    ManualReviewAutomatedReviewLogPayload
  >,
  'mutationFn' | 'mutationKey'
>;

const manualReview = (payload: ManualReviewAutomatedReviewLogPayload) => {
  return API.post(
    '/api/internal/scheduled-hosts-reviews/manual-review',
    payload,
  );
};

const useManualReviewMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: manualReview,
    ...options,
  });
};

export default useManualReviewMutation;
